import React from "react";
import { Col, Row } from "antd";

import { AdditionalInformationForm } from "../../forms";
import { UserTopBar } from "components/user";
import {ElementVisibility, Localize} from "components/service";


const ProfileTabAdditionalInfo = ({ me }) => {

    return (
        <div>
            <ElementVisibility
                maxWidth={ 768 }
                type="show"
                comparison="<"
            >
                <UserTopBar
                    itsMe
                    title={ <Localize wrap>GLOBAL.Title_AdditionalInfo</Localize> }
                    backLink={ `/${me.nickname}` }
                />
            </ElementVisibility>
            <Row type="flex" className="profile-row">
                <Col span={24}>
                    <AdditionalInformationForm me={me} />
                </Col>
            </Row>
        </div>
    );
};

export default ProfileTabAdditionalInfo;